import { useEffect, useState } from "react";
import PortalLayout from "../../components/PortalLayout";
import { api, formatApiErrorDetail } from "../../lib/api";

export default function AdminTeamPage() {
  const [members, setMembers] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get("/admin/team")
      .then(({ data }) => setMembers(data.members || []))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message));
  }, []);

  return (
    <PortalLayout>
      <section
        className="max-w-[1180px] mx-auto px-6 sm:px-8 pt-14 pb-8"
        data-testid="admin-team-page"
      >
        <div className="br-fade-up">
          <div className="br-overline">Team di gestione</div>
          <h1 className="font-serif-display text-[clamp(2.2rem,4vw,3.2rem)] mt-3">
            Roster Borealis.
          </h1>
          <p className="text-[0.95rem] text-[color:var(--br-text-dim)] mt-3 max-w-[640px]">
            Visibile lato cliente solo dopo il completamento dell'iter KYC. Lato admin sempre
            visibile. Profili regolati FINRA: il link apre il PDF brokercheck ufficiale.
          </p>
        </div>

        {error && (
          <div className="mt-6 br-card p-4 text-[color:var(--br-red)]" data-testid="team-error">
            {String(error)}
          </div>
        )}

        <div
          className="mt-10 grid md:grid-cols-2 xl:grid-cols-3 gap-5 br-fade-up br-delay-1"
          data-testid="admin-team-grid"
        >
          {members.map((m) => (
            <div
              key={m.crd_number}
              className="br-card p-6"
              data-testid={`admin-team-card-${m.crd_number}`}
            >
              <div
                className="font-mono-fin text-[0.6rem] tracking-[0.22em] uppercase"
                style={{ color: "var(--br-bronze)" }}
              >
                {m.role}
              </div>
              <h3 className="font-serif-display text-[1.4rem] mt-2 text-[color:var(--br-parchment)] leading-tight">
                {m.name}
              </h3>
              <div className="mt-4 grid grid-cols-2 gap-3">
                <div>
                  <div className="font-mono-fin text-[0.6rem] tracking-[0.22em] uppercase text-[color:var(--br-text-dim)]">
                    CRD#
                  </div>
                  <div
                    className="font-mono-fin mt-1 text-[0.95rem]"
                    style={{ color: "var(--br-parchment)" }}
                  >
                    {m.crd_number}
                  </div>
                </div>
                <div>
                  <div className="font-mono-fin text-[0.6rem] tracking-[0.22em] uppercase text-[color:var(--br-text-dim)]">
                    Esperienza
                  </div>
                  <div
                    className="font-serif-display text-[1.5rem] mt-1"
                    style={{ color: "var(--br-bronze)" }}
                  >
                    {m.years_experience}
                    <span className="text-[0.7rem] font-mono-fin ml-1">anni</span>
                  </div>
                </div>
              </div>
              <a
                href={m.finra_url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-5 inline-block font-mono-fin text-[0.66rem] tracking-[0.22em] uppercase border px-3 py-2"
                style={{ borderColor: "var(--br-bronze-soft)", color: "var(--br-bronze)" }}
                data-testid={`admin-team-finra-${m.crd_number}`}
              >
                Profilo FINRA →
              </a>
            </div>
          ))}
        </div>
      </section>
    </PortalLayout>
  );
}
